import { createSlice } from "@reduxjs/toolkit";
import { resetStore } from "src/store/actions";
import { handleSearchOSitems } from "src/pages/CreateOverShort/slice/CreateOsReducers";
import {
  handleAddApproverAttachment,
  handleAddAttachment,
  handleAddOSitems,
  handleEditOver,
  handleEnableSort,
  handleFulFillForUploadAttachment,
  handleFulfilledForFetchOverShortDetails,
  handleFulfilledForFetchTransferDetails,
  handlePendingForFetchOverShortDetails,
  handlePendingForFetchTransferDetails,
  handlePendingForUploadAttachment,
  handleRejectForUploadAttachment,
  handleRejectedForFetchOverShortDetails,
  handleRejectedForFetchTransferDetails,
  handleRemoveApproverAttachment,
  handleRemoveAttachment,
  handleRemoveOSitem,
  handleUpdateApproverNotes,
  handleUpdateOSnavigationBlock,
  handleUpdateNotes,
  handleUpdateOsNotes,
  initialState,
  handleResetEditOS,
  handleCombineOsAndTransferItems,
  handleSelectAllPalletItems,
  handleEditShortItems,
  handleGetStoreCreditDetailsForOSPending,
  handleGetStoreCreditDetailsForOSFulfilled,
  handleGetStoreCreditDetailsForOSRejected
} from "./EditOsReducers";
import {
  fetchOverShortDetails,
  fetchTransferDetails,
  getStoreCreditDetailsForOS,
  uploadAttachments
} from "./EditOsAsyncThunks";

const editOverShortSlice = createSlice({
  name: "editOs",
  initialState,
  reducers: {
    handleResetEditOS,
    handleAddOSitems,
    handleSearchOSitems,
    handleUpdateOsNotes,
    handleUpdateApproverNotes,
    handleRemoveOSitem,
    handleEditOver,
    handleEditShortItems,
    handleEnableSort,
    handleUpdateOSnavigationBlock,
    handleAddAttachment,
    handleRemoveAttachment,
    handleUpdateNotes,
    handleAddApproverAttachment,
    handleRemoveApproverAttachment,
    handleCombineOsAndTransferItems,
    handleSelectAllPalletItems
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, () => initialState)
      .addCase(uploadAttachments.pending, handlePendingForUploadAttachment)
      .addCase(uploadAttachments.fulfilled, handleFulFillForUploadAttachment)
      .addCase(uploadAttachments.rejected, handleRejectForUploadAttachment)
      .addCase(
        fetchOverShortDetails.pending,
        handlePendingForFetchOverShortDetails
      )
      .addCase(
        fetchOverShortDetails.fulfilled,
        handleFulfilledForFetchOverShortDetails
      )
      .addCase(
        fetchOverShortDetails.rejected,
        handleRejectedForFetchOverShortDetails
      )
      .addCase(
        getStoreCreditDetailsForOS.pending,
        handleGetStoreCreditDetailsForOSPending
      )
      .addCase(
        getStoreCreditDetailsForOS.fulfilled,
        handleGetStoreCreditDetailsForOSFulfilled
      )
      .addCase(
        getStoreCreditDetailsForOS.rejected,
        handleGetStoreCreditDetailsForOSRejected
      )
      .addCase(
        fetchTransferDetails.pending,
        handlePendingForFetchTransferDetails
      )
      .addCase(
        fetchTransferDetails.fulfilled,
        handleFulfilledForFetchTransferDetails
      )
      .addCase(
        fetchTransferDetails.rejected,
        handleRejectedForFetchTransferDetails
      );
  }
});

export const {
  handleResetEditOS: resetEditOverShortSlice,
  handleAddOSitems: addOverShortItem,
  handleSearchOSitems: searchOverShortItems,
  handleUpdateOsNotes: updateOverShortNotes,
  handleUpdateApproverNotes: updateOverShortApproverNotes,
  handleRemoveOSitem: removeOverShortItem,
  handleEditOver: editOver,
  handleEditShortItems: editShort,
  handleEnableSort: enableSort,
  handleUpdateOSnavigationBlock: updateNavigationBlocking,
  handleAddAttachment: addAttachment,
  handleRemoveAttachment: removeAttachment,
  handleUpdateNotes: updateNotes,
  handleAddApproverAttachment: addApproverAttachment,
  handleRemoveApproverAttachment: removeApproverAttachment,
  handleCombineOsAndTransferItems: combineOsAndTransferItems,
  handleSelectAllPalletItems: selectAllPalletItems
} = editOverShortSlice.actions;

export default editOverShortSlice.reducer;
